import { render } from "./BanobagiRightsCountdown.vue?vue&type=template&id=073624dc&scoped=true"
import script from "./BanobagiRightsCountdown.vue?vue&type=script&lang=js"
export * from "./BanobagiRightsCountdown.vue?vue&type=script&lang=js"

import "./BanobagiRightsCountdown.vue?vue&type=style&index=0&id=073624dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073624dc"]])

export default __exports__